import { PureDate } from 'src/shared-utilities/models/pureDate';

export class PepDisclosureModel {
  isInitialized = false;
  isPep?: boolean | null = undefined;
  firstName: string;
  lastName: string;
  pepStatus: PepStatusesEnum;
  pepPosition: PepPositionsEnum;
  pepRelationship: PepRelationshipsEnum;
  organizationName: string;
  positionCountry: string;
  datePositionStart: PureDate = new PureDate(undefined, undefined, undefined);
  datePositionEnd: PureDate = new PureDate(undefined, undefined, undefined);
  isActivePosition?: boolean | null = undefined;
  positionTitle: string;
  isProvidingFunding?: boolean | null = undefined;
  sourceOfFunds: string;
}

export class PepValidationModel {
  firstNameValid = true;
  lastNameValid = true;
  pepStatusValid = true;
  organizationNameValid = true;
  positionCountryValid = true;
  datePositionStartValid = true;
  datePositionEndValid = true;
  stilInPositionValid = true;
  positionNameValid = true;
  positionTitleValid = true;
  relationshipValid = true;
  providingFundingValid = true;
  sourceOfFundsValid = true;

  public isValid(): boolean {
    return (
      this.firstNameValid &&
      this.lastNameValid &&
      this.pepStatusValid &&
      this.organizationNameValid &&
      this.positionCountryValid &&
      this.datePositionStartValid &&
      this.datePositionEndValid &&
      this.stilInPositionValid &&
      this.positionNameValid &&
      this.positionTitleValid &&
      this.relationshipValid &&
      this.providingFundingValid &&
      this.sourceOfFundsValid
    );
  }
}

export abstract class PepStatuses {
  static get pepStatuses(): Array<PepStatuses> {
    /**return a copy of the institutions constants to prevent editing the values*/
    return this._pepStatuses.map(element => ({ ...element }));
  }

  private static readonly _pepStatuses: Array<PepStatuses> = [
    {
      id: 1,
      text: $localize`:@@submit_pepDeclaration_ForeignPEP:Foreign PEP`,
    },
    {
      id: 2,
      text: $localize`:@@submit_pepDeclaration_DomesticPEP:Domestic PEP`,
    },
  ];
}

export enum PepStatusesEnum {
  ForeignPEP = 1,
  DomesticPEP = 2,
}

export class PepPosition {
  id: number;
  text: string;
}

export abstract class PepPositions {
  static get pepPositions(): Array<PepPosition> {
    /**return a copy of the institutions constants to prevent editing the values*/
    return this._pepPositions.map(element => ({ ...element }));
  }

  private static readonly _pepPositions: Array<PepPosition> = [
    {
      id: 1,
      text: $localize`:@@submit_pepDeclaration_HeadOfState:Head of State or Head of Government, including Governor General and Lieutenant Governor`,
    },
    {
      id: 2,
      text: $localize`:@@submit_pepDeclaration_ExecutiveCouncilMember:Member of Executive Council of Government or Member of a Legislature`,
    },
    {
      id: 3,
      text: $localize`:@@submit_pepDeclaration_InternationalOrgHead:Head of an International Organization`,
    },
    {
      id: 4,
      text: $localize`:@@submit_pepDeclaration_GovAgencyHead:Head of a Government Agency`,
    },
    {
      id: 5,
      text: $localize`:@@submit_pepDeclaration_MilitaryGeneral:Military General (or higher rank)`,
    },
    {
      id: 6,
      text: $localize`:@@submit_pepDeclaration_CrownCorpPresident:President of a Corporation wholly owned by Her Majesty in Right of Canada or a Province`,
    },
    {
      id: 7,
      text: $localize`:@@submit_pepDeclaration_OrgLeaderMultinationFunded:Leader of an Organization Funded by Multiple Nations or States`,
    },
    {
      id: 8,
      text: $localize`:@@submit_pepDeclaration_DeputyMinister:Deputy Minister (or equivalent)`,
    },
    {
      id: 9,
      text: $localize`:@@submit_pepDeclaration_AmbassadorAttache:Ambassador or Ambassador’s Attaché or Councilor`,
    },
    {
      id: 10,
      text: $localize`:@@submit_pepDeclaration_StateOwnedBankPresident:President of a State-Owned Bank or Company`,
    },
    {
      id: 11,
      text: $localize`:@@submit_pepDeclaration_PoliticalPartyLeader:Leader or President of a Political Party in a Legislature`,
    },
    {
      id: 12,
      text: $localize`:@@submit_pepDeclaration_LegislatureMember:Member of the Senate or House of Commons, or member of Legislature`,
    },
    {
      id: 13,
      text: $localize`:@@submit_pepDeclaration_Judge:Judge`,
    },
    {
      id: 14,
      text: $localize`:@@submit_pepDeclaration_CanadianMayor:Mayor in Canada`,
    },
  ];
}

export enum PepPositionsEnum {
  HeadOfState = 1,
  ExecutiveCouncilMember = 2,
  InternationalOrgHead = 3,
  GovAgencyHead = 4,
  MilitaryGeneral = 5,
  CrownCorpPresident = 6,
  OrgLeaderMultinationFunded = 7,
  DeputyMinister = 8,
  AmbassadorAttaché = 9,
  StateOwnedBankPresident = 10,
  PoliticalPartyLeader = 11,
  LegislatureMember = 12,
  Judge = 13,
  CanadianMayor = 14,
}

export abstract class PepRelationships {
  static get pepRelationships(): Array<PepRelationships> {
    /**return a copy of the institutions constants to prevent editing the values*/
    return this._pepRelationships.map(element => ({ ...element }));
  }

  private static readonly _pepRelationships: Array<PepRelationships> = [
    {
      id: 1,
      text: $localize`:@@submit_pepDeclaration_Self:Self`,
    },
    {
      id: 2,
      text: $localize`:@@submit_pepDeclaration_FamilyMember:Family Member`,
    },
    {
      id: 3,
      text: $localize`:@@submit_pepDeclaration_Close:Close associate`,
    },
  ];
}

export enum PepRelationshipsEnum {
  Self = 1,
  FamilyMember = 2,
  CloseAssociate = 3,
}
